"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialog = void 0;
var utils_1 = require("../utils");
var types_1 = require("../types");
exports.useDialog = function () {
    var dispatch = utils_1.useFusionContext().dispatch;
    return function (content, actions, config) {
        var id = "dialog-" + new Date().getTime().toString();
        var payload = { id: id, content: content, actions: actions, config: config };
        dispatch({ type: types_1.ActionType.ADD_DIALOG, payload: payload });
    };
};
